/* eslint no-underscore-dangle: 0 */
import { AUTH_CACHE, AUTH_SUCCESS, SESSION_SUCCESS, UNAUTH } from 'actionTypes';

const initialState = false;
export default function(state = initialState, action) {
  switch (action.type) {
    case AUTH_CACHE:
    case AUTH_SUCCESS:
    case SESSION_SUCCESS:
      return true;
    case UNAUTH:
      return false;
    default: {
      const { type, payload } = action;
      if (type && type.endsWith('_FAIL') && payload && payload.error && payload.error.status === 401) {
        return false;
      }
      return state;
    }
  }
}
